import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ModalService } from '../../../../../../../../libs/utils/ng-shared-components/src/lib/services/modal.service';
import { CustomFormBuilder } from '../../../../../../../../libs/utils/ng-shared-components/src/lib/validation/form-builder/custom-form-builder';
import { BcuReportDto, BcuReportDtoFormGroup } from '../../../../../api/dtos/BcuReportDto';
import { ApiAdminBcuReport } from '../../../../../api/endpoints/ApiAdminBcuReport';
import { BankFiltersDto } from '../../../../../api/dtos/BankFiltersDto';
import { NotificationService } from '../../../../../../../../libs/utils/ng-shared-components/src';

@Component({
  standalone: false,
  selector: 'mf-create-bcu-report-popup',
  templateUrl: './create-bcu-report-popup.component.html',
  styleUrls: ['./create-bcu-report-popup.component.scss'],
})
export class CreateBcuReportPopupComponent {
  constructor(
    private _cfb: CustomFormBuilder,
    private _apiAdminBcuReport: ApiAdminBcuReport,
    private _modalService: ModalService,
    private _notificationService: NotificationService
  ) {}

  today: Date = new Date();

  bcuReportForm = this._cfb.group<BcuReportDtoFormGroup>({
    startDate: [null, Validators.required, 'Fecha desde'],
    endDate: [null, Validators.required, 'Fechas hasta'],
    bank: [null, Validators.required, 'Banco'],
    bankId: ['', Validators.required],
  });

  async createBcuReport(bcuReportDto: BcuReportDto) {
    if (bcuReportDto.startDate > bcuReportDto.endDate) {
      this._notificationService.showError('La fecha de inicio del reporte debe ser anterior a la fecha de cierre');
      return;
    }
    await this._apiAdminBcuReport.create(bcuReportDto);
    this._modalService.closeAsSuccess('El reporte se creo con éxito');
  }

  openBcuReportPopup() {
    return;
  }

  close() {
    this._modalService.closeAsSuccess('');
  }
}
